import { observer } from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import WarningAndMessagesEditor from "./warning-and-messages-editor";

const WarningAndMessagesEditorPage: React.FC = observer(() => {
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Content', 'Warning and Error Messages']);
    }, [setSubTitles]);

    const { selectedLocale } = useTranslation();

    return (
        <TranslationScope scope="tracking-portal" locale={selectedLocale}>
            <WarningAndMessagesEditor />
        </TranslationScope>
    );
});

export default WarningAndMessagesEditorPage;